export const blocAConstants = {
  GET_BLOCA_REQUEST: 'GET_BLOCA_REQUEST',
  GET_BLOCA_SUCCESS: 'GET_BLOCA_SUCCESS',
  GET_BLOCA_FAILURE: 'GET_BLOCA_FAILURE',

  UPDATE_BLOCA_REQUEST: 'UPDATE_BLOCA_REQUEST',
  UPDATE_BLOCA_SUCCESS: 'UPDATE_BLOCA_SUCCESS',
  UPDATE_BLOCA_FAILURE: 'UPDATE_BLOCA_FAILURE',
};
